import type { CanDeactivateFn } from '@angular/router';

/** Implemented by any routed component that can hold unsaved user input,
 *  so {@link unsavedChangesGuard} can ask it whether it's safe to leave. */
export interface ConfirmsUnsavedChanges {
  confirmDiscardIfDirty(): boolean | Promise<boolean>;
}

/**
 * Generic CanDeactivate guard: defers entirely to the component's own dirty
 * check + confirmation UI, so it can be reused across any route without
 * knowing what "dirty" means for that feature.
 */
export const unsavedChangesGuard: CanDeactivateFn<ConfirmsUnsavedChanges> = (component) =>
  component.confirmDiscardIfDirty();
